import React, { SFC, JSX } from "react";
import withTheme, { PropsType as withThemeProps } from "../../hoc/withTheme";
import Button from "../Button";
import "./style.scss";

type PropsType = withThemeProps &
    HTMLProps<HTMLDivElement> & {
        button?: string;
        image: {
            src: string;
            srcSet: string;
        };
        text: string;
        title: string;
        url?: string;
        target?: boolean;
    };

const Card: SFC<PropsType> = (props: PropsType): JSX.Element => {
    return (
        <div id={props.id} className="Card">
            <div className="Card__image" style={{ color: props.theme.fill ? props.theme.fill : "inherit" }}>
                <img src={props.image.src} srcSet={props.image.srcSet} sizes="100vw" />
            </div>
            <div className="Card__content">
                <h2 className="Card__title" style={{ color: props.theme.text ? props.theme.text : "inherit" }}>
                    {props.title}
                </h2>
                <div className="Card__text" dangerouslySetInnerHTML={{ __html: props.text }} />
            </div>
            {props.url !== undefined && (
                <div className="Card__button">
                    <Button url={props.url} theme={props.theme} target={props.target}>
                        {props.button}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default withTheme(Card);
